import { useState, useEffect } from 'react';
import "./MonthAndYearSelectors.css";
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';

const MonthAndYearSelectors = (props) =>{
    const months = [
        { label: "January", value: 0 },
        { label: "February", value: 1 },
        { label: "March", value: 2 },
        { label: "April", value: 3 },
        { label: "May", value: 4 },
        { label: "June", value: 5 },
        { label: "July", value: 6 },
        { label: "August", value: 7 },
        { label: "September", value: 8 },
        { label: "October", value: 9 },
        { label: "November", value: 10 },
        { label: "December", value: 11 }
    ];

    const [ getYear, setYear ] = useState("");
    const [ getMonth, setMonth ] = useState("");
    const [ getYearsList, setYearsList ] = useState([]);
    const [ getMonthsList, setMonthsList ] = useState(months);

    const currentYear = new Date().getFullYear();
    
    const fillYears = () => {
        const years = [];
        
        for(let i=0; i<5; i++){
            years.push(currentYear - i);
        }

        setYearsList(years);
        setYear(years[0]);      //select by defautt current year
    }

    const setSelectedYear = (year) => {
        setYear(year);
        props.callBack(year, getMonth);
    }
    
    const setSelectedMonth = (month) => {
        setMonth(month);
        props.callBack(getYear, month);
    }

    useEffect(() =>{
        fillYears();

        if(getMonthsList.length > 0){
            let currentMonth = new Date().getMonth();   //select by defautt current month
            setMonth(getMonthsList[currentMonth].value);
        }
    }, [])
    
    return (
        <div className="metrics-input-container">
            <div className='flex items-center'>
                <FormControl variant="standard" sx={{ m: 1, minWidth: 120 }} size="small">
                    <Select
                        labelId="demo-simple-select-label"
                        id="year-select-input"
                        value={ getYear }
                        label="Years"
                        onChange={(e) => setSelectedYear(e.target.value)}
                    >
                        {
                            getYearsList.map((year, index) => (
                                <MenuItem value={ year } key={ Math.random() + index }>{ year }</MenuItem>
                            ))
                        }
                    </Select>
                </FormControl>
                
                <FormControl variant="standard" sx={{ m: 1, minWidth: 120 }} size="small">
                    <Select
                        labelId="demo-simple-select-label"
                        id="month-select-input"
                        value={ getMonth }
                        label="Months"
                        onChange={(e) => setSelectedMonth(e.target.value)}
                    >
                        {
                            getMonthsList.map((e, index) => (
                                <MenuItem value={ e.value } key={ Math.random() + index }>{ e.label }</MenuItem>
                            ))
                        }
                    </Select>
                </FormControl>
            </div>
        </div>
    )
}

export default MonthAndYearSelectors;